module.exports = __webpack_public_path__ + "static/media/ThebanHorseman.6fb42398.jpg";